import CloseIcon from "@mui/icons-material/Close";
import LocalShipping from "@mui/icons-material/LocalShipping";
import { IconButton } from "@mui/material";
import styled from "styled-components";

export const ContainerBox = styled.div`
	border-radius: 4px;
	color: ${({ theme }) => theme.pantoneBlack};
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	overflow-x: auto;
	padding: 10px;
	margin-top: 0.5rem;
`;

export const HeaderBox = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		flex-direction: column;
	}
`;
export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	margin: 1rem 0 0;
`;
export const ContainerTitleBox = styled.div`
	display: flex;
	align-items: flex-end;
	gap: 0.2rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
	}
`;
export const ContainerButtonsBox = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.4rem;

	> button {
		padding: 0.2rem 1rem;
	}
`;

export const TitleBox = styled.h6`
	font-weight: bold;
	margin: 0;
`;
export const TitleBoxWarning = styled.span`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.2rem;
	font-size: 0.9rem;
	line-height: 1.2em;
	color: ${({ theme }) => theme.red};
`;

export const BodyBox = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	transition: background 0.3s ease-out;
	width: 100%;

	&:hover {
		background: ${({ theme }) => theme.hoverGray};
	}
`;

export const ContainerPart = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	gap: 0.4rem;

	> img {
		object-fit: contain;
		padding: 5px;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		align-items: flex-start;
		flex-direction: column;
		gap: 0.4rem;

		> button {
			width: 100%;
			max-width: 100%;
		}
	}
`;
export const TextPriceCap = styled.span`
	margin: 0 0.4rem 0 auto;
`;
export const ColumnPart = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	overflow: hidden;
	text-overflow: ellipsis;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		align-items: flex-start;
		justify-content: space-between;
		width: 100%;
	}
`;

export const PartInfo = styled.div`
	width: 550px;
	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		width: 500px;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		width: 160px;
	}
`;

export const ContainerPartPrice = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	margin: 0 0 0 auto;

	> h6 {
		font-weight: bold;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		margin: 0;
	}
`;

export const ButtonCorrectPrice = styled.span`
	display: inline-flex;
	margin-right: 0.5rem;
`;

export const IconClose = styled(CloseIcon)`
	&&& {
		cursor: pointer;
	}
`;
export const IconButtonClose = styled(IconButton)`
	&&& {
		/* position: absolute;
    top: 0;
    right: 0; */
	}
`;

export const IconShipping = styled(LocalShipping)`
	&&& {
		transform: rotateY(180deg);
	}
`;

export const ContainerDelivery = styled.div`
	display: flex;
	flex-direction: row;
	margin-top: 20px;
`;

export const ContainerDeliveryPrice = styled.div`
	display: flex;
	justify-content: space-between;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		flex-direction: column;
	}
`;

export const ContainerInfoDelivery = styled.div`
	display: flex;
`;
export const Quantity = styled.div`
	border: 1px solid ${({ theme }) => theme.pantone2726C};
	width: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 20%;
	margin: 0 1rem;
`;

export const ContentText = styled.p`
	margin: 0;
`;

export const TextFreeShipping = styled.h6`
	color: ${({ theme }) => theme.pantone2727C};
	margin-left: 0.5rem;
`;

export const AreaButtonAbsolute = styled.div`
	position: absolute;
	top: 0.6rem;
	right: 0.6rem;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	gap: 0.4rem;
`;

export const ContainerModalConfirmation = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	background: ${({ theme }) => theme.white};
	border-radius: 8px;
	padding: 1rem;

	h6 {
		font-weight: bold;
		color: #000;
		text-align: center;
	}
`;

export const ContainerPartNoCollpase = styled.div`
	border: 1px solid ${({ theme }) => theme.pantone642C};
	border-radius: 4px;
	width: 100%;
	overflow: hidden;
`;
export const WrapperHeaderNoCollpase = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;
	padding: 0.4rem;
	overflow: auto;
	transition: background 0.3s ease-out;

	&:hover {
		background: ${({ theme }) => theme.hoverGray};
	}
`;
